export default function paragraph() {
  /**
   * Remove empty paragraphs
   */
  $("p").each(function() {
    if (
      $(this)
        .text()
        .trim() === "" &&
      $(this).children().length === 0
    ) {
      if ($(this).closest(".paragraph-wrapper").length) {
        $(this)
          .closest(".paragraph-wrapper")
          .remove();
      } else {
        $(this).remove();
      }
    }
  });
}
